import { render, staticRenderFns } from "./StoriesHome.vue?vue&type=template&id=32a22154&"
import script from "./StoriesHome.vue?vue&type=script&lang=js&"
export * from "./StoriesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports